/**
 * 회원에게 영어 메일로 나가는 글을 받는 칸 — 칸 아래 안내 한 줄, 한글이 있으면 그 까닭(빨강).
 *
 * 사장님 2026-10-02 「일단 영어로만 설정해줘, 외국에 살고있는 한국인이 우리에게 이메일로 요청사항에 한국어를 써서
 * 보냈어도 우리는 답변이 영어로 나가는거지」: 회원에게 가는 글(파트너 신청 거절 사유·스페셜 퇴출 사유·자료 메일
 * 제목/본문·자동 메일 틀)은 영어로만 받는다. 한글이 있으면 부르는 쪽이 확인 단추를 잠근다(서버도 거절한다).
 *
 * 한글 범위는 거래소 서버 `Hangul`(core.i18n)(완성형 AC00–D7A3, 자모 1100–11FF, 호환 자모 3130–318F)과 같다.
 */
const HANGUL = /[\uAC00-\uD7A3\u1100-\u11FF\u3130-\u318F]/

/** 글에 한글이 있는가(서버와 같은 범위). */
export function hasKorean(text: string): boolean {
  return HANGUL.test(text)
}

/** 회원에게 가는 사유 칸의 안내(사유가 영어 메일로 간다). */
export const REASON_MAIL_HINT = 'This reason is sent to the member in an English mail. Write it in English.'

/**
 * 칸 아래 안내 — `hint` 는 늘, `texts` 가운데 하나라도 한글이 있으면 그 까닭을 빨갛게 보인다.
 * `blocked` 는 그 까닭 문장(어느 칸이 왜 막혔는지 — 예 「The reason has Korean letters. [Reject] stays off …」).
 */
export function EnglishOnlyNote({ texts, hint, blocked }: {
  texts: readonly string[]
  hint: string
  blocked: string
}) {
  const korean = texts.some(hasKorean)
  return (
    <div className="flex flex-col gap-0.5 text-xs">
      <p className="text-slate-500">{hint}</p>
      {korean && <p role="alert" className="text-red-700 dark:text-red-400">{blocked}</p>}
    </div>
  )
}
